<template>
  <div class="div_prim"
    v-loading="loading_ad_settings"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(211, 227, 218, 0.8)"
    >
    <el-row :gutter="60">
      <el-col :span="24" class="card-01">
        <el-row>
          <el-col :span="24" class="modal_title middle_blue">Správa číselníků
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="modal_title green">Pacient
          </el-col>
          <el-col :span="15">
            <div class="card-modal white">
              <el-collapse v-model="activeNamesPat" @change="collapspat">
                <el-collapse-item  title="Fokální deficit"  name="1">
                  <el-row>
                    <el-col :span="24">
                      <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="pat_cis_prv_priz_fok_def_new" class="btn-green"> Nový název</el-button>
                    </el-col>
                    <el-table
                      ref=""
                      :data="l_pat_cis_prv_priz_fok_def"
                      style="width: 100%; word-break: normal;"
                      row-key=""
                      border
                      highlight-current-row
                    >
                      <el-table-column
                        prop="deficit_nazev"
                        label="Název deficitu"
                        min-width="300"
                        sortable
                        >
                      </el-table-column>
                      <el-table-column
                        min-width="150"
                        label="Akce"
                        align="right">
                        <template slot-scope="props">
                          <el-tooltip content="Edit" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="pat_cis_prv_priz_fok_def_edit( props.$index, props.row, $event )"></el-button>
                          </el-tooltip>
                          <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="pat_cis_prv_priz_fok_def_delete( props.$index, props.row, $event )"></el-button>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item  title="Predispozice - syndrom"  name="2">
                  <el-row>
                    <el-col :span="24">
                      <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="pat_cis_syn_pre_var_new" class="btn-green"> Nový syndrom</el-button>
                    </el-col>
                    <el-table
                      ref=""
                      :data="l_pat_cis_syn_pre_var"
                      style="width: 100%; word-break: normal;"
                      row-key=""
                      border
                      highlight-current-row
                    >
                      <el-table-column
                        prop="nazev_syndrom"
                        label="Syndrom"
                        min-width="300"
                        sortable
                        >
                      </el-table-column>
                      <el-table-column
                        min-width="150"
                        label="Akce"
                        align="right">
                        <template slot-scope="props">
                          <el-tooltip content="Edit" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="pat_cis_syn_pre_var_edit( props.$index, props.row, $event )"></el-button>
                          </el-tooltip>
                          <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="pat_cis_syn_pre_var_delete( props.$index, props.row, $event )">
                            </el-button>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="Predispozice - gen" name="3">
                  <el-row>
                    <el-col :span="24">
                      <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="pat_cis_syn_pre_gen_new" class="btn-green"> Nový gen</el-button>
                    </el-col>
                    <el-table
                      ref=""
                      :data="l_pat_cis_syn_pre_gen"
                      style="width: 100%; word-break: normal;"
                      row-key=""
                      border
                      highlight-current-row
                      @sort-change="SortChange_pat_cis_syn_pre_gen"
                      >
                      <el-table-column
                        prop="nazev_gen"
                        label="Gen"
                        min-width="300"
                        sortable="custom"
                        >
                      </el-table-column>
                      <el-table-column
                        min-width="150"
                        label="Akce"
                        align="right"
                      >
                        <template slot-scope="props">
                          <el-tooltip content="Edit" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="pat_cis_syn_pre_gen_edit( props.$index, props.row, $event )"></el-button>
                          </el-tooltip>
                          <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="pat_cis_syn_pre_gen_delete( props.$index, props.row, $event )">
                            </el-button>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item  title="Pojišťovna"  name="4">
                  <el-row>
                    <el-col :span="24">
                      <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="pat_insurance_companies_new" class="btn-green"> Nová pojišťovna</el-button>
                    </el-col>
                    <el-table
                      ref="insurance_companies"
                      :data="l_insurance_companies"
                      style="width: 100%; word-break: normal;"
                      row-key="id_inco"
                      :default-sort="{prop: 'id_inco', order: 'ascending'}"
                      border
                      highlight-current-row
                      @sort-change="SortChange_incos"
                    >
                      <el-table-column
                        prop="id_inco"
                        label="Kód pojišťovny"
                        min-width="150"
                        sortable
                        >
                      </el-table-column>
                      <el-table-column
                        prop="inco_name"
                        label="Název pojišťovny"
                        min-width="300"
                        sortable="custom"
                        >
                      </el-table-column>
                      <el-table-column
                        min-width="150"
                        label="Akce"
                        align="right">
                        <template slot-scope="props">
                          <el-tooltip content="Edit" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="pat_insurance_companies_edit( props.$index, props.row, $event )"></el-button>
                          </el-tooltip>
                          <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="pat_insurance_companies_delete( props.$index, props.row, $event )"></el-button>>
                            </el-button>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item  title="Škola"  name="5">
                  <el-row>
                    <el-col :span="24">
                      <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="pat_skola_new" class="btn-green"> Nová škola</el-button>
                    </el-col>
                    <el-table
                      ref="pat_skola"
                      :data="skoly"
                      style="width: 100%; word-break: normal;"
                      row-key="id_skola"
                      :default-sort="{prop: 'id_skola', order: 'ascending'}"
                      border
                      highlight-current-row
                    >
                      <el-table-column
                        prop="skola"
                        label="Typ školy"
                        min-width="150"
                        sortable
                        >
                      </el-table-column>
                      <el-table-column
                        prop="uroven"
                        label="Úroveň"
                        min-width="300"
                        sortable
                        >
                      </el-table-column>
                      <el-table-column
                        min-width="150"
                        label="Akce"
                        align="right"
                        >
                        <template slot-scope="props">
                          <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="pat_skola_delete( props.$index, props.row, $event )">
                            </el-button>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="pb-30">
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="modal_title green">Diagnóza/událost
          </el-col>
          <el-col :span="15">
            <div class="card-modal white">
              <el-collapse v-model="activeNamesExam" @change="collapsexam">
                <el-collapse-item  title="Lokalizace topo (primární/šíření)" name="1">
                  <el-row>
                    <el-col :span="24">
                      <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="exam_cis_pn_lok_topo_prim_new" class="btn-green"> Nový název</el-button>
                    </el-col>
                    <el-table
                      ref=""
                      :data="l_exam_cis_pn_lok_topo_prim"
                      style="width: 100%; word-break: normal;"
                      row-key="id_exam_cis_pn_lok_topo_prim"
                      border
                      highlight-current-row
                      @sort-change="SortChange_lok_topo_prims"
                    >
                      <el-table-column
                        prop="nazev_pn_lok_topo_prim"
                        label="Název"
                        min-width="400"
                        sortable="custom"
                        >
                      </el-table-column>
                      <el-table-column
                        min-width="150"
                        label="Akce"
                        align="right">
                        <template slot-scope="props">
                          <el-tooltip content="Edit" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="exam_cis_pn_lok_topo_prim_edit( props.$index, props.row, $event )"></el-button>
                          </el-tooltip>
                          <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="exam_cis_pn_lok_topo_prim_delete( props.$index, props.row, $event )">
                            </el-button>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="Diagnóza - skupina" name="2">
                  <el-row>
                    <el-col :span="24">
                      <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="exam_cis_diag_group_new" class="btn-green"> Nová skupina</el-button>
                    </el-col>
                    <el-table
                      ref="diag_groups_table"
                      :data="l_diag_groups"
                      style="width: 100%; word-break: normal;"
                      row-key="dg_name"
                      :default-sort="{prop: 'dg_name', order: 'ascending'}"
                      border
                      highlight-current-row
                      >
                      <el-table-column
                        prop="id_diag_group"
                        label="ID skupiny diagnóz"
                        min-width="150"
                        sortable
                        >
                      </el-table-column>
                      <el-table-column
                        prop="dg_name"
                        label="Název skupiny diagnóz"
                        min-width="250"
                        sortable
                        >
                      </el-table-column>
                      <el-table-column
                        min-width="150"
                        label="Akce"
                        align="right">
                        <template slot-scope="props">
                          <el-tooltip content="Edit" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="exam_cis_diag_group_edit( props.$index, props.row, $event )"></el-button>
                          </el-tooltip>
                          <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="exam_cis_diag_group_delete( props.$index, props.row, $event )">
                            </el-button>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="Diagnóza - název" name="3">
                  <el-row>
                    <el-col :span="24">
                      <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="exam_cis_diag_new" class="btn-green"> Nová diagnóza</el-button>
                    </el-col>
                    <el-table
                      ref="diags_table"
                      :data="l_cis_diags"
                      style="width: 100%; word-break: normal; "
                      row-key="d_name"
                      :default-sort="{prop: 'd_name', order: 'ascending'}"
                      border
                      highlight-current-row
                    >
                      <el-table-column
                        prop="id_diag"
                        label="ID diagnózy"
                        min-width="130"
                        sortable
                      >
                      </el-table-column>
                      <el-table-column
                        prop="d_name"
                        label="Název diagnózy"
                        min-width="300"
                        sortable
                      >
                      </el-table-column>
                      <el-table-column
                        prop="dg_name"
                        label="Název skupiny"
                        min-width="250"
                        sortable
                      >
                      </el-table-column>
                      <el-table-column
                        min-width="150"
                        label="Akce"
                        align="right">
                        <template slot-scope="props">
                          <el-tooltip content="Edit" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="exam_cis_diag_edit( props.$index, props.row, $event )"></el-button>
                          </el-tooltip>
                          <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                            <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="exam_cis_diag_delete( props.$index, props.row, $event )">
                            </el-button>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="pb-30">
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="modal_title green">Operace
          </el-col>
          <el-col :span="15">
            <el-row>
              <el-col :span="24">
                <div class="card-modal white">
                  <el-collapse v-model="activeNamesOp" @change="collapsop">
                    <el-collapse-item  title="Řešení komplikací"  name="1">
                      <el-row>
                        <el-col :span="24">
                          <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="op_cis_res_kompl_new" class="btn-green"> Nový název</el-button>
                        </el-col>
                        <el-table
                          ref="op_cis_res_kompl"
                          :data="op_komplikace"
                          style="width: 100%; word-break: normal;"
                          row-key="id_op_cis_res_kompl"
                          :default-sort="{prop: 'id_op_cis_res_kompl', order: 'ascending'}"
                          border
                          highlight-current-row
                        >
                          <el-table-column
                            prop="nazev_kompl"
                            label="Název"
                            min-width="300"
                            sortable
                            >
                          </el-table-column>
                          <el-table-column
                            prop="podnazev_kompl"
                            label="Podnázev"
                            min-width="300"
                            sortable
                            >
                          </el-table-column>
                          <el-table-column
                            min-width="150"
                            label="Akce"
                            align="right">
                            <template slot-scope="props">
                              <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                                <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" @click="op_cis_res_kompl_delete( props.$index, props.row, $event )" icon="el-icon-delete" >
                                </el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-row>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </el-col>
              <el-col class="pb-30">
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="pb-30">
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="modal_title green">Kontrola
          </el-col>
          <el-col :span="15">
            <el-row>
              <el-col :span="24">
                <div class="card-modal white">
                  <el-collapse v-model="activeNamesCheck" @change="collapscheck">
                    <el-collapse-item  title="Oddělení" name="1">
                      <el-row>
                        <el-col :span="24">
                          <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="check_cis_dept_new" class="btn-green"> Nový název</el-button>
                        </el-col>
                        <el-table
                          ref=""
                          :data="l_check_cis_dept"
                          style="width: 100%; word-break: normal;"
                          row-key=""
                          border
                          highlight-current-row
                        >
                          <el-table-column
                            prop="dept_name"
                            label="Název oddělení"
                            min-width="300"
                            sortable
                            >
                          </el-table-column>
                          <el-table-column
                            min-width="150"
                            label="Akce"
                            align="right">
                            <template slot-scope="props">
                              <el-tooltip content="Edit" placement="top" effect="light" :open-delay="500">
                                <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" @click="check_cis_dept_edit( props.$index, props.row, $event )" icon="el-icon-edit" ></el-button>
                              </el-tooltip>
                              <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                                <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" @click="check_cis_dept_delete( props.$index, props.row, $event )" icon="el-icon-delete" >
                                </el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-row>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </el-col>
              <el-col class="pb-30">
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="pb-30">
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="modal_title green">Léčba
          </el-col>
          <el-col :span="15">
            <el-row>
              <el-col :span="24">
                <div class="card-modal white">
                  <el-collapse v-model="activeNamesMed" @change="collapsmed">
                    <el-collapse-item title="Číselník protokolu" name="1">
                      <el-row>
                        <el-col :span="24">
                          <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="med_ciselnik_protokolu_new" class="btn-green"> Nový protokol</el-button>
                        </el-col>
                        <el-table
                          ref="med_protokoly_table"
                          :data="med_cis_protokol"
                          style="width: 100%; word-break: normal;"
                          row-key="nazev_protokol"
                          :default-sort="{prop: 'nazev_protokol', order: 'ascending'}"
                          border
                          highlight-current-row
                        >
                          <el-table-column
                            prop="nazev_protokol"
                            label="Protokol"
                            min-width="300"
                            sortable
                            >
                          </el-table-column>

                          <el-table-column
                            min-width="150"
                            label="Akce"
                            align="right">
                            <template slot-scope="props">
                              <el-tooltip content="Edit" placement="top" effect="light" :open-delay="500">
                                <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="med_ciselnik_protokolu_edit( props.$index, props.row, $event )"></el-button>
                              </el-tooltip>
                              <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                                <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="med_ciselnik_protokolu_delete( props.$index, props.row, $event )">
                                </el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-row>
                    </el-collapse-item>
                    <el-collapse-item  title="Chemoterapie intenzivní - cytostatika" name="2">
                      <el-row>
                        <el-col :span="24">
                          <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="med_cis_chem_int_cyt_new" class="btn-green"> Nový název</el-button>
                        </el-col>
                        <el-table
                          ref=""
                          :data="l_med_cis_chem_int_cyt"
                          style="width: 100%; word-break: normal;"
                          row-key=""
                          border
                          highlight-current-row
                        >
                          <el-table-column
                            prop="cytostatika_nazev"
                            label="Cytostatika"
                            min-width="300"
                            sortable
                            >
                          </el-table-column>
                          <el-table-column
                            min-width="150"
                            label="Akce"
                            align="right">
                            <template slot-scope="props">
                              <el-tooltip content="Edit" placement="top" effect="light" :open-delay="500">
                                <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="med_cis_chem_int_cyt_edit( props.$index, props.row, $event )"></el-button>
                              </el-tooltip>
                              <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                                <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="med_cis_chem_int_cyt_delete( props.$index, props.row, $event )">
                                </el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-row>
                    </el-collapse-item>
                    <el-collapse-item  title="Druh komplikace" name="3">
                      <el-row>
                        <el-col :span="24">
                          <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="med_cis_kompl_dr_new" class="btn-green"> Nový název</el-button>
                        </el-col>
                        <el-table
                          ref="med_cis_kompl_dr"
                          :data="med_komplikace"
                          style="width: 100%; word-break: normal;"
                          row-key="id_med_cis_kompl_dr"
                          :default-sort="{prop: 'id_med_cis_kompl_dr', order: 'ascending'}"
                          border
                          highlight-current-row
                        >
                          <el-table-column
                            prop="nazev_kompl"
                            label="Název"
                            width="280"
                            sortable
                            >
                          </el-table-column>
                          <el-table-column
                            prop="stupen_kompl"
                            label="Hodnota"
                            min-width=""
                            sortable
                            >
                          </el-table-column>
                          <el-table-column
                            min-width="150"
                            label="Akce"
                            align="right">
                            <template slot-scope="props">
                              <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                                <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" @click="med_cis_kompl_dr_delete( props.$index, props.row, $event )" icon="el-icon-delete" >
                                </el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-row>
                    </el-collapse-item>
                    <el-collapse-item title="Chemoterapie intenzivní intrathekální/intraventrikulární cytostatika" name="4">
                      <el-row>
                        <el-col :span="24">
                          <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="med_cis_chem_int_inthe_inver_cyt_new" class="btn-green"> Nová cytostatika</el-button>
                        </el-col>
                        <el-table
                          ref=""
                          :data="l_med_cis_chem_int_inthe_inver_cyt"
                          style="width: 100%; word-break: normal;"
                          row-key=""
                          :default-sort="{prop: 'cytostatika_nazev', order: 'ascending'}"
                          border
                          highlight-current-row
                          >
                          <el-table-column
                            prop="cytostatika_nazev"
                            label="Cytostatika"
                            min-width="300">
                          </el-table-column>
                          <el-table-column
                            min-width="150"
                            label="Akce"
                            align="right">
                            <template slot-scope="props">
                              <el-tooltip content="Edit" placement="top" effect="light" :open-delay="500">
                                <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="med_cis_chem_int_inthe_inver_cyt_edit( props.$index, props.row, $event )"></el-button>
                              </el-tooltip>
                              <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                                <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="med_cis_chem_int_inthe_inver_cyt_delete( props.$index, props.row, $event )">
                                </el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-row>
                    </el-collapse-item>
                    <el-collapse-item title="Udržovací/metronomická chemoterapie cytostatika" name="5">
                      <el-row>
                        <el-col :span="24">
                          <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="med_cis_udr_chem_inthe_inver_cyt_new" class="btn-green"> Nový název</el-button>
                        </el-col>
                        <el-table
                          ref=""
                          :data="l_med_cis_udr_chem_inthe_inver_cyt"
                          style="width: 100%; word-break: normal;"
                          row-key=""
                          :default-sort="{prop: 'cytostatika_nazev', order: 'ascending'}"
                          border
                          highlight-current-row
                          >
                          <el-table-column
                            prop="cytostatika_nazev"
                            label="Cytostatika"
                            min-width="300">
                          </el-table-column>
                          <el-table-column
                            min-width="150"
                            label="Akce"
                            align="right">
                            <template slot-scope="props">
                              <el-tooltip content="Edit" placement="top" effect="light" :open-delay="500">
                                <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="med_cis_udr_chem_inthe_inver_cyt_edit( props.$index, props.row, $event )"></el-button>
                              </el-tooltip>
                              <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                                <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="med_cis_udr_chem_inthe_inver_cyt_delete( props.$index, props.row, $event )">
                                </el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-row>
                    </el-collapse-item>
                    <el-collapse-item  title="Biologická/cílená terapie - lék" name="6">
                      <el-row>
                        <el-col :span="24">
                          <el-button :disabled="!loginuser.editor" icon="el-icon-plus" size="mini" @click="med_cis_bio_ter_lek_new" class="btn-green"> Nový název</el-button>
                        </el-col>
                        <el-table
                          ref=""
                          :data="l_med_cis_bio_ter_lek"
                          style="width: 100%; word-break: normal;"
                          row-key=""
                          border
                          highlight-current-row
                        >
                          <el-table-column
                            prop="lek_nazev"
                            label="Název léku"
                            min-width="300"
                            sortable
                            >
                          </el-table-column>
                          <el-table-column
                            min-width="150"
                            label="Akce"
                            align="right">
                            <template slot-scope="props">
                              <el-tooltip content="Edit" placement="top" effect="light" :open-delay="500">
                                <el-button :disabled="!loginuser.editor" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="med_cis_bio_ter_lek_edit( props.$index, props.row, $event )"></el-button>
                              </el-tooltip>
                              <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                                <el-button :disabled="!loginuser.editor" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="med_cis_bio_ter_lek_delete( props.$index, props.row, $event )">
                                </el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-row>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </el-col>
              <el-col class="pb-30">
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-dialog :visible.sync="modal_pat_insurance_companies" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-form ref="form_pat_insurance_companies" size="mini" :rules="rules_pat_insurance_companies" :model="pat_insurance_companies">
        <el-row>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Kód pojišťovny</div>
            <el-form-item prop="id_inco">
              <el-input
                        type="number"
                        :readonly="pat_insurance_companies.inco_name_old !== ''"
                        placeholder=""
                        v-model="pat_insurance_companies.id_inco"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="pat_insurance_companies.inco_name_old !== ''" :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název pojišťovny - původní</div>
            <el-input type="text"
                      :readonly="true"
                      placeholder=""
                      v-model="pat_insurance_companies.inco_name_old"
                      size="small"
                      >
            </el-input>
          </el-col>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název pojišťovny - nový</div>
            <el-form-item prop="inco_name">
              <el-input type="text"
                        placeholder=""
                        v-model="pat_insurance_companies.inco_name"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="pat_insurance_companies.inco_name_old === ''" class="btn-green-big" link @click.native="pat_insurance_companies_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-else type="info" link @click.native="pat_insurance_companies_edit_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_pat_insurance_companies_close" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_pat_skola" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-form ref="form_skola" size="mini" :rules="rules_pat_skola" :model="pat_skola_model">
        <el-row>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název školy - nový</div>
            <el-form-item prop="skola">
              <el-input type="text"
                        placeholder=""
                        v-model="pat_skola_model.skola"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Úroveň - nová</div>
            <el-form-item prop="uroven">
              <el-input type="text"
                        placeholder=""
                        v-model="pat_skola_model.uroven"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="text-center mt-3">
            <el-button class="btn-green-big" link @click.native="pat_skola_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button class="btn-blue" link @click.native="modal_pat_skola_close('form_skola')" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_pat_cis_syn_pre_var" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-form ref="form_pat_cis_syn_pre_var" size="mini" :rules="rules_pat_cis_syn_pre_var" :model="pat_cis_syn_pre_var">
        <el-row>
          <el-col v-if="pat_cis_syn_pre_var.nazev_syndrom_old !== ''" :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název syndromu - původní</div>
            <el-input type="text"
                      :readonly="true"
                      placeholder=""
                      v-model="pat_cis_syn_pre_var.nazev_syndrom_old"
                      size="small"
                      >
            </el-input>
          </el-col>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název syndromu - nový</div>
            <el-form-item prop="nazev_syndrom_new">
              <el-input type="text"
                        placeholder=""
                        v-model="pat_cis_syn_pre_var.nazev_syndrom_new"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="pat_cis_syn_pre_var.nazev_syndrom_old === ''" class="btn-green-big" link @click.native="pat_cis_syn_pre_var_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-else type="info" link @click.native="pat_cis_syn_pre_var_edit_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_pat_cis_syn_pre_var_close" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_pat_cis_syn_pre_gen" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-form ref="form_pat_cis_syn_pre_gen" size="mini" :rules="rules_pat_cis_syn_pre_gen" :model="pat_cis_syn_pre_gen">
        <el-row>
          <el-col v-if="pat_cis_syn_pre_gen.nazev_gen_old !== ''" :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název genu - původní</div>
            <el-input type="text"
                      :readonly="true"
                      placeholder=""
                      v-model="pat_cis_syn_pre_gen.nazev_gen_old"
                      size="small"
                      >
            </el-input>
          </el-col>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název genu - nový</div>
            <el-form-item prop="nazev_gen_new">
              <el-input type="text"
                        placeholder=""
                        v-model="pat_cis_syn_pre_gen.nazev_gen_new"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="pat_cis_syn_pre_gen.nazev_gen_old === ''" class="btn-green-big" link @click.native="pat_cis_syn_pre_gen_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-else type="info" link @click.native="pat_cis_syn_pre_gen_edit_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_pat_cis_syn_pre_gen_close" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_pat_cis_prv_priz_fok_def" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-form ref="form_pat_fokalni_deficit" size="mini" :rules="rules_pat_fokalni_deficit" :model="pat_fokalni_deficit">
        <el-row>
          <el-col v-if="pat_fokalni_deficit.deficit_nazev_old !== ''" :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název deficitu - původní</div>
            <el-input type="text"
                      :readonly="true"
                      placeholder=""
                      v-model="pat_fokalni_deficit.deficit_nazev_old"
                      size="small"
                      >
            </el-input>
          </el-col>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název deficitu - nový</div>
            <el-form-item prop="deficit_nazev_new">
              <el-input type="text"
                        placeholder=""
                        v-model="pat_fokalni_deficit.deficit_nazev_new"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="pat_fokalni_deficit.deficit_nazev_old === ''" class="btn-green-big" link @click.native="pat_cis_prv_priz_fok_def_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-else type="info" link @click.native="pat_cis_prv_priz_fok_def_edit_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_pat_cis_prv_priz_fok_def_close" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_exam_cis_diag_group" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-form ref="form_exam_cis_diag_group" size="mini" :rules="rules_exam_cis_diag_group" :model="exam_cis_diag_group">
        <el-row>
          <!-- <el-col span="24" style="text-align: right">
            <el-tooltip class="item" effect="dark" content="Bude doplněno" placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-col> -->
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> ID skupiny diagnóz</div>
            <el-input
              type="number"
              :readonly="exam_cis_diag_group.dg_name_old !== '' || exam_cis_diag_group.id_diag_group_old !== ''"
              placeholder=""
              v-model="exam_cis_diag_group.id_diag_group"
              size="small"
              >
            </el-input>
            <!-- <el-input type="text"
                      :readonly="dg_name_old !== '' || dg_name_new !== '' || id_diag_group_old !== ''"
                      placeholder=""
                      v-model="id_diag_group"
                      size="small"
                      >
            </el-input> -->
          </el-col>

          <el-col v-if="exam_cis_diag_group.id_diag_group_old !== ''" :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název skupiny diagnóz - původní</div>
            <el-input type="text"
                      :readonly="true"
                      placeholder=""
                      v-model="exam_cis_diag_group.dg_name_old"
                      size="small"
                      >
            </el-input>
          </el-col>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název skupiny diagnóz - nový</div>
            <el-form-item prop="d_name_new">
              <el-input type="text"
                        placeholder=""
                        v-model="exam_cis_diag_group.dg_name_new"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="exam_cis_diag_group.id_diag_group_old === ''" :disabled="exam_cis_diag_group.id_diag_group == '' || exam_cis_diag_group.dg_name_new == ''" class="btn-green-big" link @click.native="exam_cis_diag_group_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-else :disabled="exam_cis_diag_group.id_diag_group == '' || exam_cis_diag_group.dg_name_new == ''" type="info" link @click.native="exam_cis_diag_group_edit_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_exam_cis_diag_group_close" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_exam_cis_diag" width="600px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-form ref="form_exam_cis_diag" size="mini" :rules="rules_exam_cis_diag" :model="exam_cis_diag">
        <el-row>
          <el-col span="24" style="text-align: right">
            <!-- <el-tooltip class="item" effect="dark" content="Bude doplněno" placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip> -->
          </el-col>
          <el-col v-if="exam_cis_diag.d_name_old === ''" :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Skupina diagnóz</div>
            <el-form-item prop="id_diag_group">
              <el-select
                v-model="exam_cis_diag.id_diag_group"
                default-first-option
                filterable
                clearable
                placeholder="Vyber skupinu diagńoz"
                >
                <el-option
                  v-for="item of l_diag_groups"
                  :key="item.id_diag_group"
                  :label="item.dg_name"
                  :value="item.id_diag_group">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col v-if="exam_cis_diag.d_name_old === ''" :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> ID diagnózy</div>
            <el-form-item prop="id_diag">
              <el-input
                type="number"
                v-model="exam_cis_diag.id_diag"
                size="small"
                :readonly="exam_cis_diag.d_name_old !== ''"
                >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col v-if="exam_cis_diag.d_name_old !== ''" :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název diagnózy - původní</div>
            <el-input type="text"
                      placeholder=""
                      v-model="exam_cis_diag.d_name_old"
                      size="small"
                      >
            </el-input>
          </el-col>

          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název diagnózy - nový</div>
            <el-form-item prop="d_name_new">
              <el-input type="text"
                        placeholder=""
                        v-model="exam_cis_diag.d_name_new"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="exam_cis_diag.d_name_old === ''" class="btn-green-big" link @click.native="exam_cis_diag_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-else type="info" link @click.native="exam_cis_diag_edit_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_exam_cis_diag_close" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_exam_cis_pn_lok_topo_prim" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-form ref="form_exam_pn_lokalizace_topo" size="mini" :rules="rules_exam_pn_lokalizace_topo" :model="exam_pn_lokalizace_topo">
        <el-row>
          <el-col v-if="exam_pn_lokalizace_topo.nazev_pn_lok_topo_prim_old !== ''" :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název lokalizace - původní</div>
            <el-input type="text"
                      :readonly="true"
                      placeholder=""
                      v-model="exam_pn_lokalizace_topo.nazev_pn_lok_topo_prim_old"
                      size="small"
                      >
            </el-input>
          </el-col>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název lokalizace - nový</div>
            <el-form-item prop="nazev_pn_lok_topo_prim_new">
              <el-input type="text"
                        placeholder=""
                        v-model="exam_pn_lokalizace_topo.nazev_pn_lok_topo_prim_new"
                        size="small"
                        >
              </el-input>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="exam_pn_lokalizace_topo.nazev_pn_lok_topo_prim_old === ''" class="btn-green-big" link @click.native="exam_cis_pn_lok_topo_prim_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-else type="info" link @click.native="exam_cis_pn_lok_topo_prim_edit_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_exam_cis_pn_lok_topo_prim_close" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_op_cis_res_kompl" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-form ref="form_op_cis_res_kompl" size="mini" :rules="rules_op_komplikace" :model="op_res_kompl_model">
        <el-row>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název komplikace - nový</div>
            <el-form-item prop="nazev_kompl">
              <el-input type="text"
                        placeholder=""
                        v-model="op_res_kompl_model.nazev_kompl"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Podnázev komplikace - nový</div>
            <el-form-item prop="podnazev_kompl">
              <el-input type="text"
                        placeholder=""
                        v-model="op_res_kompl_model.podnazev_kompl"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="text-center mt-3">
            <el-button class="btn-green-big" link @click.native="op_cis_res_kompl_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button class="btn-blue" link @click.native="modal_op_cis_res_kompl_close('form_op_cis_res_kompl')" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_med_cis_chem_int_cyt" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-form ref="form_med_cis_chem_int_cyt" size="mini" :rules="rules_med_cis_chem_int_cyt" :model="med_cis_chem_int_cyt">
        <el-row>
          <el-col v-if="med_cis_chem_int_cyt.cytostatika_nazev_old !== ''" :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název cytostatik - původní</div>
            <el-input type="text"
                      :readonly="true"
                      placeholder=""
                      v-model="med_cis_chem_int_cyt.cytostatika_nazev_old"
                      size="small"
                      >
            </el-input>
          </el-col>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název cytostatik - nový</div>
            <el-form-item prop="cytostatika_nazev_new">
              <el-input type="text"
                        placeholder=""
                        v-model="med_cis_chem_int_cyt.cytostatika_nazev_new"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="med_cis_chem_int_cyt.cytostatika_nazev_old === ''" class="btn-green-big" link @click.native="med_cis_chem_int_cyt_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-else type="info" link @click.native="med_cis_chem_int_cyt_edit_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_med_cis_chem_int_cyt_close" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_med_cis_protokol" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-form ref="form_med_cis_protokol" size="mini" :rules="rules_med_cis_protokol" :model="my_med_cis_protokol">
        <el-row>
          <el-col v-if="my_med_cis_protokol.id_med_cis_protokol > 0" :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název protokolu - původní</div>
            <el-input type="text"
                      :readonly="true"
                      placeholder=""
                      v-model="my_med_cis_protokol.nazev_protokol_old"
                      size="small"
                      >
            </el-input>
          </el-col>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název protokolu - nový</div>
            <el-form-item prop="nazev_protokol_new">
              <el-input type="text"
                        placeholder=""
                        v-model="my_med_cis_protokol.nazev_protokol_new"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="my_med_cis_protokol.id_med_cis_protokol === 0" class="btn-green-big" link @click.native="med_ciselnik_protokolu_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-else type="info" link @click.native="med_ciselnik_protokolu_edit_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_med_cis_protokol_close('form_med_cis_protokol')" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_med_cis_chem_int_inthe_inver_cyt" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-row>
        <el-col v-if="cytostatika_nazev_old !== ''" :span="24">
          <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název cytostatik - původní</div>
          <el-input type="text"
                    :readonly="true"
                    placeholder=""
                    v-model="cytostatika_nazev_old"
                    size="small"
                    >
          </el-input>
        </el-col>
        <el-col :span="24">
          <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span>  Název cytostatik - nový</div>
          <el-input type="text"
                    placeholder=""
                    v-model="cytostatika_nazev_new"
                    size="small"
                    >
          </el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="text-center mt-3">
          <el-button v-if="cytostatika_nazev_old === ''" class="btn-green-big" link @click.native="med_cis_chem_int_inthe_inver_cyt_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
          <el-button v-else type="info" link @click.native="med_cis_chem_int_inthe_inver_cyt_edit_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
          <el-button class="btn-blue" link @click.native="modal_med_cis_chem_int_inthe_inver_cyt = false" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog :visible.sync="modal_med_cis_udr_chem_inthe_inver_cyt" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-row>
        <el-col v-if="cytostatika_udr_nazev_old !== ''" :span="24">
          <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název cytostatik - původní</div>
          <el-input type="text"
                    :readonly="true"
                    placeholder=""
                    v-model="cytostatika_udr_nazev_old"
                    size="small"
                    >
          </el-input>
        </el-col>
        <el-col :span="24">
          <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název cytostatik - nový</div>
          <el-input type="text"
                    placeholder=""
                    v-model="cytostatika_udr_nazev_new"
                    size="small"
                    >
          </el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="text-center mt-3">
          <el-button v-if="cytostatika_udr_nazev_old === ''" class="btn-green-big" link @click.native="med_cis_udr_chem_inthe_inver_cyt_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
          <el-button v-else type="info" link @click.native="med_cis_udr_chem_inthe_inver_cyt_edit_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
          <el-button class="btn-blue" link @click.native="modal_med_cis_udr_chem_inthe_inver_cyt = false" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog :visible.sync="modal_med_cis_kompl_dr" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-form ref="form_med_cis_kompl_dr" size="mini" :rules="rules_med_cis_kompl_dr" :model="med_cis_kompl_dr">
        <el-row>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název komplikace - nový</div>
            <el-form-item prop="nazev_kompl">
              <el-input type="text"
                        placeholder=""
                        v-model="med_cis_kompl_dr.nazev_kompl"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Stupeň komplikace - nový</div>
            <el-form-item prop="stupen_kompl">
              <el-input-number
                v-model="med_cis_kompl_dr.stupen_kompl"
                size="small"
                :min="1"
                :max="4"
                :precision="0"
                >
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="text-center mt-3">
            <el-button class="btn-green-big" link @click.native="med_cis_kompl_dr_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button class="btn-blue" link @click.native="modal_med_cis_kompl_dr_close('form_med_cis_kompl_dr')" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_med_cis_bio_ter_lek" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-form ref="form_med_cis_bio_ter_lek" size="mini" :rules="rules_med_cis_bio_ter_lek" :model="med_cis_bio_ter_lek">
        <el-row>
          <el-col v-if="med_cis_bio_ter_lek.id_med_cis_bio_ter_lek > 0" :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název léku - původní</div>
            <el-input type="text"
                      :readonly="true"
                      placeholder=""
                      v-model="med_cis_bio_ter_lek.lek_nazev_old"
                      size="small"
                      >
            </el-input>
          </el-col>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název léku - nový</div>
            <el-form-item prop="lek_nazev_new">
              <el-input type="text"
                        placeholder=""
                        v-model="med_cis_bio_ter_lek.lek_nazev_new"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="med_cis_bio_ter_lek.id_med_cis_bio_ter_lek === 0" class="btn-green-big" link @click.native="med_cis_bio_ter_lek_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-else type="info" link @click.native="med_cis_bio_ter_lek_edit_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_med_cis_bio_ter_lek_close" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_check_cis_dept" width="400px" custom-class="my-dialog-01" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="true" :close-on-press-escape="true">
      <el-form ref="form_check_cis_dept" size="mini" :rules="rules_check_cis_dept" :model="check_cis_dept">
        <el-row>
          <el-col v-if="check_cis_dept.dept_name_old !== ''" :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název oddělení - původní</div>
            <el-input type="text"
                      :readonly="true"
                      placeholder=""
                      v-model="check_cis_dept.dept_name_old"
                      size="small"
                      >
            </el-input>
          </el-col>
          <el-col :span="24">
            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Název oddělení - nový</div>
            <el-form-item prop="dept_name_new">
              <el-input type="text"
                        placeholder=""
                        v-model="check_cis_dept.dept_name_new"
                        size="small"
                        >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="check_cis_dept.dept_name_old === ''" class="btn-green-big" link @click.native="check_cis_dept_new_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-else type="info" link @click.native="check_cis_dept_edit_save" size="mini"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_check_cis_dept_close" size="mini"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
  import Vue from 'vue';
  import moment from 'moment';

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import axios from 'axios';

  import { Loading } from 'element-ui';

  let notifier = new Vue();

  export default {
    computed: {
      ...mapState({

          loginuser: state => state.loginuser,

          l_insurance_companies: state => state.l_insurance_companies,

          l_pat_skola: state => state.l_pat_skola,
          skoly: state => state.skoly,

          l_pat_cis_prv_priz_fok_def: state => state.l_pat_cis_prv_priz_fok_def,

          l_pat_cis_syn_pre_var: state => state.l_pat_cis_syn_pre_var,

          l_pat_cis_syn_pre_gen: state => state.l_pat_cis_syn_pre_gen,
          sorting_pat_cis_syn_pre_gen: state => state.sorting_pat_cis_syn_pre_gen,

          l_exam_cis_diag_groups: state => state.exam_cis_diag_groups,

          l_exam_cis_diags: state => state.exam_cis_diags,

          l_diag_groups: state => state.l_diag_groups,
          l_cis_diags: state => state.l_cis_diags,

          l_exam_cis_pn_lok_topo_prim: state => state.l_exam_cis_pn_lok_topo_prim,

          l_op_cis_res_kompl: state => state.l_op_cis_res_kompl,
          op_komplikace: state => state.op_komplikace,

          med_cis_protokol: state => state.med_cis_protokol,

          l_med_cis_chem_int_inthe_inver_cyt: state => state.l_med_cis_chem_int_inthe_inver_cyt,

          l_med_cis_udr_chem_inthe_inver_cyt: state => state.l_med_cis_udr_chem_inthe_inver_cyt,

          l_med_cis_chem_int_cyt: state => state.l_med_cis_chem_int_cyt,

          l_med_cis_kompl_dr: state => state.l_med_cis_kompl_dr,
          med_komplikace: state => state.med_komplikace,

          l_med_cis_bio_ter_lek: state => state.l_med_cis_bio_ter_lek,

          l_check_cis_dept: state => state.l_check_cis_dept,

          sorting_incos: state => state.sorting_incos,

          sorting_lok_topo_prims: state => state.sorting_lok_topo_prims,

          loading_ad_settings: state => state.loading_ad_settings,


      }),

      ...mapGetters({

      }),



    },


    data () {
      return {
        modal_pat_insurance_companies: false,
        pat_insurance_companies: {
          id_inco: null,
          inco_name_old: "",
          inco_name: "",
        },

        modal_pat_skola: false,
        pat_skola_model: {
          skola: "",
          uroven: "",
        },
        id_skola: 0,

        modal_pat_cis_prv_priz_fok_def: false,
        pat_fokalni_deficit: {
          deficit_nazev_old: "",
          deficit_nazev_new: "",
          id_pat_cis_prv_priz_fok_def: 0,
        },

        modal_pat_cis_syn_pre_var: false,
        pat_cis_syn_pre_var: {
          nazev_syndrom_old: "",
          nazev_syndrom_new: "",
          id_pat_cis_syn_pre_var: 0,
        },

        modal_pat_cis_syn_pre_gen: false,
        pat_cis_syn_pre_gen: {
          nazev_gen_old: "",
          nazev_gen_new: "",
          id_pat_cis_syn_pre_gen: 0,
        },

        modal_exam_cis_diag_group: false,
        exam_cis_diag_group: {
          id_diag_group: "",
          id_diag_group_old: "",
          dg_name_old: "",
          dg_name_new: "",
        },

        modal_exam_cis_diag: false,
        exam_cis_diag: {
          id_diag: "",
          id_diag_group: "",
          d_name_old: "",
          d_name_new: "",
        },

        modal_exam_cis_pn_lok_topo_prim: false,
        exam_pn_lokalizace_topo: {
          nazev_pn_lok_topo_prim_old: "",
          nazev_pn_lok_topo_prim_new: "",
          id_exam_cis_pn_lok_topo_prim: 0,
        },

        modal_op_cis_res_kompl: false,
        op_res_kompl_model: {
          nazev_kompl: "",
          podnazev_kompl: "",
          id_op_cis_res_kompl: 0,
        },


        modal_med_cis_protokol: false,
        my_med_cis_protokol: {
          id_med_cis_protokol: 0,
          nazev_protokol_old: "",
          nazev_protokol_new: "",
        },


        modal_med_cis_chem_int_cyt: false,
        med_cis_chem_int_cyt: {
          cytostatika_nazev_old: "",
          cytostatika_nazev_new: "",
          id_med_cis_chem_int_cyt: 0,
        },


        modal_med_cis_chem_int_inthe_inver_cyt: false,
        cytostatika_nazev_old: "",
        cytostatika_nazev_new: "",


        modal_med_cis_udr_chem_inthe_inver_cyt: false,
        cytostatika_udr_nazev_old: "",
        cytostatika_udr_nazev_new: "",


        modal_med_cis_kompl_dr: false,
        med_cis_kompl_dr: {
          nazev_kompl: "",
          stupen_kompl: "",
          id_med_cis_kompl_dr: 0,
        },


        modal_med_cis_bio_ter_lek: false,
        med_cis_bio_ter_lek: {
          lek_nazev_old: "",
          lek_nazev_new: "",
          id_med_cis_bio_ter_lek: 0,
        },


        modal_check_cis_dept: false,
        check_cis_dept: {
          dept_name_old: "",
          dept_name_new: "",
          id_dept: 0,
        },


        activeNamesPat: [''],
        activeNamesMed: [''],
        activeNamesOp: [''],
        activeNamesCheck: [''],
        activeNamesExam: [''],


        rules_pat_insurance_companies: {
          id_inco: [
            { required: true, message: 'Kód pojišťovny je vyžadován', trigger: 'blur' },
          ],
          inco_name: [
            { required: true, message: 'Název pojišťovny je vyžadován', trigger: 'blur' },
          ],
        },

        rules_pat_skola: {
          skola: [
            { required: true, message: 'Název školy je vyžadován', trigger: 'blur' },
          ],
          uroven: [
            { required: true, message: 'Úroveň školy je vyžadována', trigger: 'blur' },
          ],
        },

        rules_pat_fokalni_deficit: {
          deficit_nazev_new: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
        },

        rules_pat_cis_syn_pre_var: {
          nazev_syndrom_new: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
        },

        rules_pat_cis_syn_pre_gen: {
          nazev_gen_new: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
        },

        rules_exam_pn_lokalizace_topo: {
          nazev_pn_lok_topo_prim_new: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
        },

        rules_exam_cis_diag_group: {
          id_diag_group: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
          dg_name_new: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
        },

        rules_exam_cis_diag: {
          id_diag: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
          id_diag_group: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
          d_name_new: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
        },

        rules_op_komplikace: {
          nazev_kompl: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
          podnazev_kompl: [
            { required: true, message: 'Podnázev je vyžadován', trigger: 'blur' },
          ],
        },

        rules_med_cis_chem_int_cyt: {
          cytostatika_nazev_new: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
        },

        rules_med_cis_kompl_dr: {
          nazev_kompl: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
        },

        rules_med_cis_bio_ter_lek: {
          lek_nazev_new: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
        },

        rules_med_cis_protokol: {
          nazev_protokol_new: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
        },

        rules_check_cis_dept: {
          dept_name_new: [
            { required: true, message: 'Název je vyžadován', trigger: 'blur' },
          ],
        },




      }
    },

    methods: {
      ...mapMutations({

      }),


      ...mapActions({

        a_pat_insurance_companies: 'a_pat_insurance_companies',
        a_pat_insurance_companies_add: 'a_pat_insurance_companies_add',
        a_pat_insurance_companies_update: 'a_pat_insurance_companies_update',
        a_pat_insurance_companies_delete: 'a_pat_insurance_companies_delete',

        a_pat_skola: 'a_pat_skola',
        a_pat_skola_add: 'a_pat_skola_add',
        a_pat_skola_delete: 'a_pat_skola_delete',

        a_pat_cis_prv_priz_fok_def: 'a_pat_cis_prv_priz_fok_def',
        a_pat_cis_prv_priz_fok_def_add: 'a_pat_cis_prv_priz_fok_def_add',
        a_pat_cis_prv_priz_fok_def_update: 'a_pat_cis_prv_priz_fok_def_update',
        a_pat_cis_prv_priz_fok_def_delete: 'a_pat_cis_prv_priz_fok_def_delete',

        a_pat_cis_syn_pre_var: 'a_pat_cis_syn_pre_var',
        a_pat_cis_syn_pre_var_add: 'a_pat_cis_syn_pre_var_add',
        a_pat_cis_syn_pre_var_update: 'a_pat_cis_syn_pre_var_update',
        a_pat_cis_syn_pre_var_delete: 'a_pat_cis_syn_pre_var_delete',

        a_pat_cis_syn_pre_gen: 'a_pat_cis_syn_pre_gen',
        a_pat_cis_syn_pre_gen_add: 'a_pat_cis_syn_pre_gen_add',
        a_pat_cis_syn_pre_gen_update: 'a_pat_cis_syn_pre_gen_update',
        a_pat_cis_syn_pre_gen_delete: 'a_pat_cis_syn_pre_gen_delete',

        a_exam_cis_diag_group_add: 'a_exam_cis_diag_group_add',
        a_exam_cis_diag_group_update: 'a_exam_cis_diag_group_update',
        a_exam_cis_diag_group_delete: 'a_exam_cis_diag_group_delete',

        a_exam_cis_diag_add: 'a_exam_cis_diag_add',
        a_exam_cis_diag_update: 'a_exam_cis_diag_update',
        a_exam_cis_diag_delete: 'a_exam_cis_diag_delete',

        a_exam_cis_diag_groups_get: 'a_exam_cis_diag_groups_get',
        a_exam_cis_diags_get: 'a_exam_cis_diags_get',

        a_exam_cis_pn_lok_topo_prim: 'a_exam_cis_pn_lok_topo_prim',
        a_exam_cis_pn_lok_topo_prim_add: 'a_exam_cis_pn_lok_topo_prim_add',
        a_exam_cis_pn_lok_topo_prim_update: 'a_exam_cis_pn_lok_topo_prim_update',
        a_exam_cis_pn_lok_topo_prim_delete: 'a_exam_cis_pn_lok_topo_prim_delete',

        a_op_cis_res_kompl: 'a_op_cis_res_kompl',
        a_op_cis_res_kompl_add: 'a_op_cis_res_kompl_add',
        a_op_cis_res_kompl_delete: 'a_op_cis_res_kompl_delete',

        a_med_cis_protokol: 'a_med_cis_protokol',
        a_med_cis_protokol_add: 'a_med_cis_protokol_add',
        a_med_cis_protokol_update: 'a_med_cis_protokol_update',
        a_med_cis_protokol_delete: 'a_med_cis_protokol_delete',

        a_med_cis_chem_int_cyt: 'a_med_cis_chem_int_cyt',
        a_med_cis_chem_int_cyt_add: 'a_med_cis_chem_int_cyt_add',
        a_med_cis_chem_int_cyt_update: 'a_med_cis_chem_int_cyt_update',
        a_med_cis_chem_int_cyt_delete: 'a_med_cis_chem_int_cyt_delete',

        a_med_cis_chem_int_inthe_inver_cyt: 'a_med_cis_chem_int_inthe_inver_cyt',
        a_med_cis_chem_int_inthe_inver_cyt_add: 'a_med_cis_chem_int_inthe_inver_cyt_add',
        a_med_cis_chem_int_inthe_inver_cyt_update: 'a_med_cis_chem_int_inthe_inver_cyt_update',
        a_med_cis_chem_int_inthe_inver_cyt_delete: 'a_med_cis_chem_int_inthe_inver_cyt_delete',

        a_med_cis_udr_chem_inthe_inver_cyt: 'a_med_cis_udr_chem_inthe_inver_cyt',
        a_med_cis_udr_chem_inthe_inver_cyt_add: 'a_med_cis_udr_chem_inthe_inver_cyt_add',
        a_med_cis_udr_chem_inthe_inver_cyt_update: 'a_med_cis_udr_chem_inthe_inver_cyt_update',
        a_med_cis_udr_chem_inthe_inver_cyt_delete: 'a_med_cis_udr_chem_inthe_inver_cyt_delete',

        a_med_cis_kompl_dr: 'a_med_cis_kompl_dr',
        a_med_cis_kompl_dr_add: 'a_med_cis_kompl_dr_add',
        a_med_cis_kompl_dr_update: 'a_med_cis_kompl_dr_update',
        a_med_cis_kompl_dr_delete: 'a_med_cis_kompl_dr_delete',

        a_med_cis_bio_ter_lek: 'a_med_cis_bio_ter_lek',
        a_med_cis_bio_ter_lek_add: 'a_med_cis_bio_ter_lek_add',
        a_med_cis_bio_ter_lek_update: 'a_med_cis_bio_ter_lek_update',
        a_med_cis_bio_ter_lek_delete: 'a_med_cis_bio_ter_lek_delete',

        a_check_cis_dept: 'a_check_cis_dept',
        a_check_cis_dept_add: 'a_check_cis_dept_add',
        a_check_cis_dept_update: 'a_check_cis_dept_update',
        a_check_cis_dept_delete: 'a_check_cis_dept_delete',

        a_ad_settings: 'a_ad_settings',

      }),


      pat_cis_syn_pre_var_new() {
        this.pat_cis_syn_pre_var.nazev_syndrom_old = "";
        this.pat_cis_syn_pre_var.nazev_syndrom_new = "";
        this.modal_pat_cis_syn_pre_var = true;
      },


      pat_cis_syn_pre_var_new_save() {
       this.$refs["form_pat_cis_syn_pre_var"].validate((valid) => {
          if (valid) {
            this.a_pat_cis_syn_pre_var_add( { nazev_syndrom: this.pat_cis_syn_pre_var.nazev_syndrom_new} );
            this.modal_pat_cis_syn_pre_var = false;
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      pat_cis_syn_pre_var_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.pat_cis_syn_pre_var.nazev_syndrom_old = row.nazev_syndrom;
        this.pat_cis_syn_pre_var.nazev_syndrom_new = "";
        this.pat_cis_syn_pre_var.id_pat_cis_syn_pre_var = row.id_pat_cis_syn_pre_var;
        this.modal_pat_cis_syn_pre_var = true;
      },


      pat_cis_syn_pre_var_edit_save() {
       this.$refs["form_pat_cis_syn_pre_var"].validate((valid) => {
          if (valid) {
            this.a_pat_cis_syn_pre_var_update( { nazev_syndrom: this.pat_cis_syn_pre_var.nazev_syndrom_new, id_pat_cis_syn_pre_var: this.pat_cis_syn_pre_var.id_pat_cis_syn_pre_var } );
            this.modal_pat_cis_syn_pre_var = false;
            this.pat_cis_syn_pre_var.nazev_syndrom_old = "";
            this.pat_cis_syn_pre_var.nazev_syndrom_new = "";
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });

      },


      pat_cis_syn_pre_var_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_pat_cis_syn_pre_var_delete( {'id_pat_cis_syn_pre_var': row.id_pat_cis_syn_pre_var} );
      },


      modal_pat_cis_syn_pre_var_close() {
        this.modal_pat_cis_syn_pre_var = false;
        this.$refs["form_pat_cis_syn_pre_var"].resetFields();
      },


      pat_cis_syn_pre_gen_new() {
        this.pat_cis_syn_pre_gen.nazev_gen_old = "";
        this.pat_cis_syn_pre_gen.nazev_gen_new = "";
        this.modal_pat_cis_syn_pre_gen = true;
      },


      pat_cis_syn_pre_gen_new_save() {
       this.$refs["form_pat_cis_syn_pre_gen"].validate((valid) => {
          if (valid) {
            this.a_pat_cis_syn_pre_gen_add( { nazev_gen: this.pat_cis_syn_pre_gen.nazev_gen_new} );
            this.modal_pat_cis_syn_pre_gen = false;
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      pat_cis_syn_pre_gen_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.pat_cis_syn_pre_gen.nazev_gen_old = row.nazev_gen;
        this.pat_cis_syn_pre_gen.nazev_gen_new = "";
        this.pat_cis_syn_pre_gen.id_pat_cis_syn_pre_gen = row.id_pat_cis_syn_pre_gen;
        this.modal_pat_cis_syn_pre_gen = true;
      },


      pat_cis_syn_pre_gen_edit_save() {
       this.$refs["form_pat_cis_syn_pre_gen"].validate((valid) => {
          if (valid) {
            this.a_pat_cis_syn_pre_gen_update( { nazev_gen: this.pat_cis_syn_pre_gen.nazev_gen_new, id_pat_cis_syn_pre_gen: this.pat_cis_syn_pre_gen.id_pat_cis_syn_pre_gen } );
            this.modal_pat_cis_syn_pre_gen = false;
            this.pat_cis_syn_pre_gen.nazev_gen_old = "";
            this.pat_cis_syn_pre_gen.nazev_gen_new = "";
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });

      },


      pat_cis_syn_pre_gen_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_pat_cis_syn_pre_gen_delete( {'id_pat_cis_syn_pre_gen': row.id_pat_cis_syn_pre_gen} );
      },


      modal_pat_cis_syn_pre_gen_close() {
        this.modal_pat_cis_syn_pre_gen = false;
        this.$refs["form_pat_cis_syn_pre_gen"].resetFields();
      },


      SortChange_pat_cis_syn_pre_gen(val) {
        console.log(val);
        this.sorting_pat_cis_syn_pre_gen.sorting_prop = val.prop;
        this.sorting_pat_cis_syn_pre_gen.sorting_ordering = val.order;
        this.a_pat_cis_syn_pre_gen();
      },


      pat_cis_prv_priz_fok_def_new() {
        this.pat_fokalni_deficit.deficit_nazev_old = "";
        this.pat_fokalni_deficit.deficit_nazev_new = "";
        this.modal_pat_cis_prv_priz_fok_def = true;
      },


      pat_cis_prv_priz_fok_def_new_save() {
       this.$refs["form_pat_fokalni_deficit"].validate((valid) => {
          if (valid) {
            this.a_pat_cis_prv_priz_fok_def_add( { deficit_nazev: this.pat_fokalni_deficit.deficit_nazev_new} );
            this.modal_pat_cis_prv_priz_fok_def = false;
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      pat_cis_prv_priz_fok_def_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.pat_fokalni_deficit.deficit_nazev_old = row.deficit_nazev;
        this.pat_fokalni_deficit.deficit_nazev_new = "";
        this.pat_fokalni_deficit.id_pat_cis_prv_priz_fok_def = row.id_pat_cis_prv_priz_fok_def;
        this.modal_pat_cis_prv_priz_fok_def = true;
      },


      pat_cis_prv_priz_fok_def_edit_save() {
       this.$refs["form_pat_fokalni_deficit"].validate((valid) => {
          if (valid) {
            this.a_pat_cis_prv_priz_fok_def_update( { deficit_nazev: this.pat_fokalni_deficit.deficit_nazev_new, id_pat_cis_prv_priz_fok_def: this.pat_fokalni_deficit.id_pat_cis_prv_priz_fok_def } );
            this.modal_pat_cis_prv_priz_fok_def = false;
            this.pat_fokalni_deficit.deficit_nazev_old = "";
            this.pat_fokalni_deficit.deficit_nazev_new = "";
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      pat_cis_prv_priz_fok_def_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_pat_cis_prv_priz_fok_def_delete( {'id_pat_cis_prv_priz_fok_def': row.id_pat_cis_prv_priz_fok_def} );
      },


      modal_pat_cis_prv_priz_fok_def_close() {
        this.modal_pat_cis_prv_priz_fok_def = false;
        this.$refs["form_pat_fokalni_deficit"].resetFields();
      },


      pat_insurance_companies_new() {
        this.pat_insurance_companies.id_inco = null;
        this.pat_insurance_companies.inco_name = "";
        this.modal_pat_insurance_companies = true;
      },


      pat_insurance_companies_new_save() {
       this.$refs["form_pat_insurance_companies"].validate((valid) => {
          if (valid) {
            this.a_pat_insurance_companies_add( { id_inco: this.pat_insurance_companies.id_inco, inco_name: this.pat_insurance_companies.inco_name} );
            this.modal_pat_insurance_companies = false;
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });

      },


      pat_insurance_companies_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.pat_insurance_companies.inco_name_old = row.inco_name;
        this.pat_insurance_companies.inco_name = "";
        this.pat_insurance_companies.id_inco = row.id_inco;
        this.modal_pat_insurance_companies = true;
      },


      pat_insurance_companies_edit_save() {
       this.$refs["form_pat_insurance_companies"].validate((valid) => {
          if (valid) {
            this.a_pat_insurance_companies_update( { inco_name: this.pat_insurance_companies.inco_name, id_inco: this.pat_insurance_companies.id_inco } );
            this.modal_pat_insurance_companies = false;
            this.pat_insurance_companies.inco_name_old = "";
            this.pat_insurance_companies.inco_name = "";
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      pat_insurance_companies_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_pat_insurance_companies_delete( {'id_inco': row.id_inco} );
        this.id_inco = null;
      },


      modal_pat_insurance_companies_close() {
        this.modal_pat_insurance_companies = false;
        this.$refs["form_pat_insurance_companies"].resetFields();
      },


      pat_skola_new() {
        this.pat_skola_model.skola = "";
        this.pat_skola_model.uroven = "";
        this.modal_pat_skola = true;
      },


      pat_skola_new_save() {
        this.$refs["form_skola"].validate((valid) => {
          if (valid) {
            this.a_pat_skola_add( { skola: this.pat_skola_model.skola, uroven: this.pat_skola_model.uroven} );
            this.modal_pat_skola = false;
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      pat_skola_delete (index, row, event) {
        this.a_pat_skola_delete( {'id_skola': row.id_skola} );
        this.id_skola = null;
      },


      modal_pat_skola_close(form_name) {
        this.modal_pat_skola = false;
        this.$refs[form_name].resetFields();
      },


      exam_cis_diag_group_new() {
        this.exam_cis_diag_group.id_diag_group = "";
        this.exam_cis_diag_group.id_diag_group_old = "";
        this.exam_cis_diag_group.dg_name_old = "";
        this.exam_cis_diag_group.dg_name_new = "";
        this.modal_exam_cis_diag_group = true;
      },


      exam_cis_diag_group_new_save() {
        this.a_exam_cis_diag_group_add( { id_diag_group: this.exam_cis_diag_group.id_diag_group, dg_name: this.exam_cis_diag_group.dg_name_new} );
        this.modal_exam_cis_diag_group = false;
      },


      exam_cis_diag_group_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.exam_cis_diag_group.dg_name_old = row.dg_name;
        this.exam_cis_diag_group.dg_note_old = row.dg_note;
        this.exam_cis_diag_group.dg_name_new = "";
        this.exam_cis_diag_group.dg_note_new = "";
        this.exam_cis_diag_group.id_diag_group = row.id_diag_group;
        this.exam_cis_diag_group.id_diag_group_old = row.id_diag_group;
        this.modal_exam_cis_diag_group = true;
      },


      exam_cis_diag_group_edit_save() {
        this.a_exam_cis_diag_group_update( { id_diag_group: this.exam_cis_diag_group.id_diag_group, id_diag_group_old: this.exam_cis_diag_group.id_diag_group_old, dg_name: this.exam_cis_diag_group.dg_name_new } );
        this.modal_exam_cis_diag_group = false;
        this.exam_cis_diag_group.dg_name_old = "";
        this.exam_cis_diag_group.dg_name_new = "";
        this.exam_cis_diag_group.dg_note_old = "";
        this.exam_cis_diag_group.dg_note_new = "";
        this.exam_cis_diag_group.id_diag_group = "";
        this.exam_cis_diag_group.id_diag_group_old = "";
      },


      exam_cis_diag_group_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_exam_cis_diag_group_delete( {'id_diag_group': row.id_diag_group} );
      },


      modal_exam_cis_diag_group_close() {
        this.modal_exam_cis_diag_group = false;
        this.$refs["form_exam_cis_diag_group"].resetFields();
      },


      exam_cis_diag_new() {
        this.exam_cis_diag.d_name_old = "";
        this.exam_cis_diag.d_name_new = "";
        this.exam_cis_diag.id_diag = "";
        this.exam_cis_diag.id_diag_group = "";
        this.a_exam_cis_diag_groups_get()
        this.modal_exam_cis_diag = true;
      },


      exam_cis_diag_new_save() {
        this.$refs["form_exam_cis_diag"].validate((valid) => {
          if (valid) {
            this.a_exam_cis_diag_add( { id_diag_group: this.exam_cis_diag.id_diag_group, id_diag: this.exam_cis_diag.id_diag,  d_name: this.exam_cis_diag.d_name_new} );
            this.modal_exam_cis_diag = false;
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      exam_cis_diag_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.exam_cis_diag.d_name_old = row.d_name;
        this.exam_cis_diag.d_name_new = "";
        this.exam_cis_diag.id_diag = row.id_diag;
        this.modal_exam_cis_diag = true;
      },


      exam_cis_diag_edit_save() {
        this.$refs["form_exam_cis_diag"].validate((valid) => {
          if (valid) {
            this.a_exam_cis_diag_update( { d_name: this.exam_cis_diag.d_name_new, id_diag: this.exam_cis_diag.id_diag } );
            this.modal_exam_cis_diag = false;
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      exam_cis_diag_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_exam_cis_diag_delete( {'id_diag': row.id_diag} );
      },


      modal_exam_cis_diag_close() {
        this.modal_exam_cis_diag = false;
        this.exam_cis_diag.d_name_old = "";
        this.exam_cis_diag.d_name_new = "";
        this.exam_cis_diag.id_diag = "";
        this.exam_cis_diag.id_diag_group = "";
        this.$refs["form_exam_cis_diag"].resetFields();
      },


      exam_cis_pn_lok_topo_prim_new() {
        this.exam_pn_lokalizace_topo.nazev_pn_lok_topo_prim_old = "";
        this.exam_pn_lokalizace_topo.nazev_pn_lok_topo_prim_new = "";
        this.modal_exam_cis_pn_lok_topo_prim = true;
      },


      exam_cis_pn_lok_topo_prim_new_save() {
        this.$refs["form_exam_pn_lokalizace_topo"].validate((valid) => {
            if (valid) {
              this.a_exam_cis_pn_lok_topo_prim_add( { nazev_pn_lok_topo_prim: this.exam_pn_lokalizace_topo.nazev_pn_lok_topo_prim_new} );
              this.modal_exam_cis_pn_lok_topo_prim = false;
            } else {
              this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
              return false;
            }
          });
      },


      exam_cis_pn_lok_topo_prim_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.exam_pn_lokalizace_topo.id_exam_cis_pn_lok_topo_prim = row.id_exam_cis_pn_lok_topo_prim;
        this.exam_pn_lokalizace_topo.nazev_pn_lok_topo_prim_old = row.nazev_pn_lok_topo_prim;
        this.exam_pn_lokalizace_topo.nazev_pn_lok_topo_prim_new = "";
        this.modal_exam_cis_pn_lok_topo_prim = true;
      },


      exam_cis_pn_lok_topo_prim_edit_save() {
        this.$refs["form_exam_pn_lokalizace_topo"].validate((valid) => {
            if (valid) {
              this.a_exam_cis_pn_lok_topo_prim_update( { nazev_pn_lok_topo_prim: this.exam_pn_lokalizace_topo.nazev_pn_lok_topo_prim_new, id_exam_cis_pn_lok_topo_prim: this.exam_pn_lokalizace_topo.id_exam_cis_pn_lok_topo_prim } );
              this.modal_exam_cis_pn_lok_topo_prim = false;
              this.exam_pn_lokalizace_topo.nazev_pn_lok_topo_prim_old = "";
              this.exam_pn_lokalizace_topo.nazev_pn_lok_topo_prim_new = "";
            } else {
              this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
              return false;
            }
          });
      },


      exam_cis_pn_lok_topo_prim_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_exam_cis_pn_lok_topo_prim_delete( {'id_exam_cis_pn_lok_topo_prim': row.id_exam_cis_pn_lok_topo_prim} );
      },


      modal_exam_cis_pn_lok_topo_prim_close() {
        this.modal_exam_cis_pn_lok_topo_prim = false;
        this.$refs["form_exam_pn_lokalizace_topo"].resetFields();
      },



      op_cis_res_kompl_new() {
        this.op_res_kompl_model.nazev_kompl = "";
        this.op_res_kompl_model.podnazev_kompl = "";
        this.modal_op_cis_res_kompl = true;
      },


      op_cis_res_kompl_new_save() {
        this.$refs["form_op_cis_res_kompl"].validate((valid) => {
          if (valid) {
            this.a_op_cis_res_kompl_add( { nazev_kompl: this.op_res_kompl_model.nazev_kompl, podnazev_kompl: this.op_res_kompl_model.podnazev_kompl} );
            this.modal_op_cis_res_kompl = false;
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      op_cis_res_kompl_delete (index, row, event) {
        this.a_op_cis_res_kompl_delete( {'id_op_cis_res_kompl': row.id_op_cis_res_kompl} );
        this.id_op_cis_res_kompl = null;
      },


      modal_op_cis_res_kompl_close(form_name) {
        this.modal_op_cis_res_kompl = false;
        this.$refs[form_name].resetFields();
      },


      med_ciselnik_protokolu_new() {
        this.my_med_cis_protokol.id_med_cis_protokol = 0;
        this.my_med_cis_protokol.nazev_protokol_old = "";
        this.my_med_cis_protokol.nazev_protokol_new = "";
        this.modal_med_cis_protokol = true;
      },


      med_ciselnik_protokolu_new_save() {
        this.$refs["form_med_cis_protokol"].validate((valid) => {
          if (valid) {
            this.a_med_cis_protokol_add( { nazev_protokol: this.my_med_cis_protokol.nazev_protokol_new} );
            this.modal_med_cis_protokol = false;
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      med_ciselnik_protokolu_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.my_med_cis_protokol.id_med_cis_protokol = row.id_med_cis_protokol;
        this.my_med_cis_protokol.nazev_protokol_old = row.nazev_protokol;
        this.my_med_cis_protokol.nazev_protokol_new = "";
        this.modal_med_cis_protokol = true;
      },


      med_ciselnik_protokolu_edit_save() {
        this.$refs["form_med_cis_protokol"].validate((valid) => {
          if (valid) {
            this.a_med_cis_protokol_update( { nazev_protokol_new: this.my_med_cis_protokol.nazev_protokol_new, id_med_cis_protokol: this.my_med_cis_protokol.id_med_cis_protokol } );
            this.modal_med_cis_protokol = false;
            this.my_med_cis_protokol.nazev_protokol_old = "";
            this.my_med_cis_protokol.nazev_protokol_new = "";
            this.my_med_cis_protokol.id_med_cis_protokol = 0;
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      med_ciselnik_protokolu_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_med_cis_protokol_delete( {'id_med_cis_protokol': row.id_med_cis_protokol} );
      },


      modal_med_cis_protokol_close(form_name) {
        this.modal_med_cis_protokol = false;
        this.$refs[form_name].resetFields();
      },


      med_cis_chem_int_cyt_new() {
        this.med_cis_chem_int_cyt.cytostatika_nazev_old = "";
        this.med_cis_chem_int_cyt.cytostatika_nazev_new = "";
        this.modal_med_cis_chem_int_cyt = true;
      },


      med_cis_chem_int_cyt_new_save() {
       this.$refs["form_med_cis_chem_int_cyt"].validate((valid) => {
          if (valid) {
            this.a_med_cis_chem_int_cyt_add( { cytostatika_nazev: this.med_cis_chem_int_cyt.cytostatika_nazev_new} );
            this.modal_med_cis_chem_int_cyt = false;
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      med_cis_chem_int_cyt_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.med_cis_chem_int_cyt.cytostatika_nazev_old = row.cytostatika_nazev;
        this.med_cis_chem_int_cyt.cytostatika_nazev_new = "";
        this.med_cis_chem_int_cyt.id_med_cis_chem_int_cyt = row.id_med_cis_chem_int_cyt;
        this.modal_med_cis_chem_int_cyt = true;
      },


      med_cis_chem_int_cyt_edit_save() {
       this.$refs["form_med_cis_chem_int_cyt"].validate((valid) => {
          if (valid) {
            this.a_med_cis_chem_int_cyt_update( { cytostatika_nazev: this.med_cis_chem_int_cyt.cytostatika_nazev_new, id_med_cis_chem_int_cyt: this.med_cis_chem_int_cyt.id_med_cis_chem_int_cyt } );
            this.modal_med_cis_chem_int_cyt = false;
            this.med_cis_chem_int_cyt.cytostatika_nazev_old = "";
            this.med_cis_chem_int_cyt.cytostatika_nazev_new = "";
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      med_cis_chem_int_cyt_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_med_cis_chem_int_cyt_delete( {'id_med_cis_chem_int_cyt': row.id_med_cis_chem_int_cyt} );
      },


      modal_med_cis_chem_int_cyt_close() {
        this.modal_med_cis_chem_int_cyt = false;
        this.$refs["form_med_cis_chem_int_cyt"].resetFields();
      },


      med_cis_chem_int_inthe_inver_cyt_new() {
        this.cytostatika_nazev_old = "";
        this.cytostatika_nazev_new = "";
        this.modal_med_cis_chem_int_inthe_inver_cyt = true;
      },


      med_cis_chem_int_inthe_inver_cyt_new_save() {
        this.a_med_cis_chem_int_inthe_inver_cyt_add( { cytostatika_nazev: this.cytostatika_nazev_new} );
        this.modal_med_cis_chem_int_inthe_inver_cyt = false;
        this.cytostatika_nazev_old = "";
        this.cytostatika_nazev_new = "";
      },


      med_cis_chem_int_inthe_inver_cyt_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.cytostatika_nazev_old = row.cytostatika_nazev;
        this.cytostatika_nazev_new = "";
        this.modal_med_cis_chem_int_inthe_inver_cyt = true;
      },


      med_cis_chem_int_inthe_inver_cyt_edit_save() {
        this.a_med_cis_chem_int_inthe_inver_cyt_update( { cytostatika_nazev_new: this.cytostatika_nazev_new, cytostatika_nazev_old: this.cytostatika_nazev_old } );
        this.modal_med_cis_chem_int_inthe_inver_cyt = false;
        this.cytostatika_nazev_old = "";
        this.cytostatika_nazev_new = "";
      },


      med_cis_chem_int_inthe_inver_cyt_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_med_cis_chem_int_inthe_inver_cyt_delete( {'cytostatika_nazev': row.cytostatika_nazev} );
      },


      med_cis_udr_chem_inthe_inver_cyt_new() {
        this.cytostatika_udr_nazev_old = "";
        this.cytostatika_udr_nazev_new = "";
        this.modal_med_cis_udr_chem_inthe_inver_cyt = true;
      },


      med_cis_udr_chem_inthe_inver_cyt_new_save() {
        this.a_med_cis_udr_chem_inthe_inver_cyt_add( { cytostatika_nazev: this.cytostatika_udr_nazev_new} );
        this.modal_med_cis_udr_chem_inthe_inver_cyt = false;
        this.cytostatika_udr_nazev_old = "";
        this.cytostatika_udr_nazev_new = "";
      },


      med_cis_udr_chem_inthe_inver_cyt_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.cytostatika_udr_nazev_old = row.cytostatika_nazev;
        this.cytostatika_udr_nazev_new = "";
        this.modal_med_cis_udr_chem_inthe_inver_cyt = true;
      },


      med_cis_udr_chem_inthe_inver_cyt_edit_save() {
        this.a_med_cis_udr_chem_inthe_inver_cyt_update( { cytostatika_udr_nazev_new: this.cytostatika_udr_nazev_new, cytostatika_udr_nazev_old: this.cytostatika_udr_nazev_old } );
        this.modal_med_cis_udr_chem_inthe_inver_cyt = false;
        this.cytostatika_udr_nazev_old = "";
        this.cytostatika_udr_nazev_new = "";
      },


      med_cis_udr_chem_inthe_inver_cyt_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_med_cis_udr_chem_inthe_inver_cyt_delete( {'cytostatika_nazev': row.cytostatika_nazev} );
      },


      med_cis_kompl_dr_new() {
        this.med_cis_kompl_dr.nazev_kompl = "";
        this.med_cis_kompl_dr.stupen_kompl = "";
        this.modal_med_cis_kompl_dr = true;
      },


      med_cis_kompl_dr_new_save() {
        this.$refs["form_med_cis_kompl_dr"].validate((valid) => {
          if (valid) {
            this.a_med_cis_kompl_dr_add( { nazev_kompl: this.med_cis_kompl_dr.nazev_kompl, stupen_kompl: this.med_cis_kompl_dr.stupen_kompl} );
            this.modal_med_cis_kompl_dr = false;
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      med_cis_kompl_dr_delete (index, row, event) {
        this.a_med_cis_kompl_dr_delete( {'id_med_cis_kompl_dr': row.id_med_cis_kompl_dr} );
        this.id_med_cis_kompl_dr = null;
      },


      modal_med_cis_kompl_dr_close(form_name) {
        this.modal_med_cis_kompl_dr = false;
        this.$refs[form_name].resetFields();
      },


      med_cis_bio_ter_lek_new() {
        this.med_cis_bio_ter_lek.lek_nazev_old = "";
        this.med_cis_bio_ter_lek.lek_nazev_new = "";
        this.med_cis_bio_ter_lek.id_med_cis_bio_ter_lek = 0;
        this.modal_med_cis_bio_ter_lek = true;
      },


      med_cis_bio_ter_lek_new_save() {
       this.$refs["form_med_cis_bio_ter_lek"].validate((valid) => {
          if (valid) {
            this.a_med_cis_bio_ter_lek_add( { lek_nazev: this.med_cis_bio_ter_lek.lek_nazev_new} );
            this.modal_med_cis_bio_ter_lek = false;
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      med_cis_bio_ter_lek_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.med_cis_bio_ter_lek.lek_nazev_old = row.lek_nazev;
        this.med_cis_bio_ter_lek.lek_nazev_new = "";
        this.med_cis_bio_ter_lek.id_med_cis_bio_ter_lek = row.id_med_cis_bio_ter_lek;
        this.modal_med_cis_bio_ter_lek = true;
      },


      med_cis_bio_ter_lek_edit_save() {
       this.$refs["form_med_cis_bio_ter_lek"].validate((valid) => {
          if (valid) {
            this.a_med_cis_bio_ter_lek_update( { lek_nazev: this.med_cis_bio_ter_lek.lek_nazev_new, id_med_cis_bio_ter_lek: this.med_cis_bio_ter_lek.id_med_cis_bio_ter_lek } );
            this.modal_med_cis_bio_ter_lek = false;
            this.med_cis_bio_ter_lek.lek_nazev_old = "";
            this.med_cis_bio_ter_lek.lek_nazev_new = "";
            this.med_cis_bio_ter_lek.id_med_cis_bio_ter_lek = 0;

          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      med_cis_bio_ter_lek_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_med_cis_bio_ter_lek_delete( {'id_med_cis_bio_ter_lek': row.id_med_cis_bio_ter_lek} );
      },


      modal_med_cis_bio_ter_lek_close() {
        this.modal_med_cis_bio_ter_lek = false;
        this.med_cis_bio_ter_lek.lek_nazev_old = "";
        this.med_cis_bio_ter_lek.lek_nazev_new = "";
        this.med_cis_bio_ter_lek.id_med_cis_bio_ter_lek = 0;
        this.$refs["form_med_cis_bio_ter_lek"].resetFields();
      },




      check_cis_dept_new() {
        this.check_cis_dept.dept_name_old = "";
        this.check_cis_dept.dept_name_new = "";
        this.modal_check_cis_dept = true;
      },


      check_cis_dept_new_save() {
       this.$refs["form_check_cis_dept"].validate((valid) => {
          if (valid) {
            this.a_check_cis_dept_add( { dept_name: this.check_cis_dept.dept_name_new} );
            this.modal_check_cis_dept = false;
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      check_cis_dept_edit (index, row, event) {
        event.stopImmediatePropagation();
        this.check_cis_dept.dept_name_old = row.dept_name;
        this.check_cis_dept.dept_name_new = "";
        this.check_cis_dept.id_dept = row.id_dept;
        this.modal_check_cis_dept = true;
      },


      check_cis_dept_edit_save() {
       this.$refs["form_check_cis_dept"].validate((valid) => {
          if (valid) {
            this.a_check_cis_dept_update( { dept_name: this.check_cis_dept.dept_name_new, id_dept: this.check_cis_dept.id_dept } );
            this.modal_check_cis_dept = false;
            this.check_cis_dept.dept_name_old = "";
            this.check_cis_dept.dept_name_new = "";
          } else {
            this.$message({ type: 'error', message: 'Některá povinná pole nejsou vyplněna!' });
            return false;
          }
        });
      },


      check_cis_dept_delete (index, row, event) {
        event.stopImmediatePropagation();
        this.a_check_cis_dept_delete( {'id_dept': row.id_dept} );
      },


      modal_check_cis_dept_close() {
        this.modal_check_cis_dept = false;
        this.$refs["form_check_cis_dept"].resetFields();
      },


      SortChange_incos(val) {
        this.sorting_incos.sorting_prop = val.prop;
        this.sorting_incos.sorting_ordering = val.order;
        this.a_pat_insurance_companies();
      },


      SortChange_lok_topo_prims(val) {
        this.sorting_lok_topo_prims.sorting_prop = val.prop;
        this.sorting_lok_topo_prims.sorting_ordering = val.order;
        this.a_exam_cis_pn_lok_topo_prim();
      },


      tableRowClassName({row, rowIndex}) {
        if (row.status === 0) {
          return 'row_0';
        } else if (row.status === 1) {
          return 'row_0';
        } else if (row.status === 2) {
          return 'row_0';
        } else if (row.status === 3) {
          return 'row_0';
        } else if (row.status === 4) {
          return 'row_0';
        } else {
          return 'row_0';
        }
      },


      handle_unavailable (index, row, event) {
        event.stopImmediatePropagation();
        alert(`Not available in trial version.`)
      },


      collapspat(val) {
        console.log(val);
      },

      collapsexam(val) {
        console.log(val);
      },

      collapsop(val) {
        console.log(val);
      },

      collapsmed(val) {
        console.log(val);
      },

      collapscheck(val) {
        console.log(val);
      },

    },


    beforeMount () {
    },


    created () {
    },


    mounted () {
      this.a_ad_settings();
      // this.a_pat_cis_syn_pre_var();
      // this.a_pat_cis_syn_pre_gen();
      // this.a_pat_cis_prv_priz_fok_def();
      // this.a_pat_skola();
      // this.a_pat_insurance_companies();


      // this.a_exam_cis_pn_lok_topo_prim();
      // this.a_exam_cis_diag_groups_get();
      // this.a_exam_cis_diags_get();

      // this.a_op_cis_res_kompl();

      // this.a_med_cis_protokol();
      // this.a_med_cis_chem_int_inthe_inver_cyt();
      // this.a_med_cis_udr_chem_inthe_inver_cyt();
      // this.a_med_cis_chem_int_cyt();
      // this.a_med_cis_kompl_dr();
      // this.a_med_cis_bio_ter_lek();

      // this.a_check_cis_dept();
    },


    beforeDestroy () {
    },


  }
</script>

<style>

.el-collapse-item__header {
  color: #7d9dbf;
  font-size: 20px;
  font-weight: 800 !important;
}

.el-loading-spinner i {
  font-size: 70px !important;
}

.el-loading-spinner {
  top: 25% !important;
}



</style>

